import { ReactElement, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Share from '@mui/icons-material/Share';
import { CustomerFacebookSection } from 'components/SocialMedia/Customers/CustomerFacebookSection';
import { CustomerInstagramSection } from 'components/SocialMedia/Customers/CustomerInstagramSection';

export interface SocialAccountSectionProps {
    facebookName: string | null;
    instagramName: string | null;
}

export function SocialAccountSection({
    facebookName,
    instagramName
}: SocialAccountSectionProps): ReactElement {
    const [expanded, setExpanded] = useState<boolean>(false);

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <Grid container spacing={1} justifyContent="space-between">
                <Grid item>
                    <Grid container alignItems="center">
                        <Grid item>
                            <Share style={{ marginTop: '-2px', marginRight: '5px' }} />
                        </Grid>
                        <Grid item>
                            <Typography variant="h5">Social Account</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography>
                        {expanded ? (
                            <ExpandLess
                                onClick={handleToggle}
                                style={{ cursor: 'pointer' }}
                            />
                        ) : (
                            <ExpandMore
                                onClick={handleToggle}
                                style={{ cursor: 'pointer' }}
                            />
                        )}
                    </Typography>
                </Grid>
            </Grid>
            <Collapse in={expanded}>
                <div style={{ marginTop: '8px' }}>
                    <CustomerFacebookSection facebookName={facebookName} />
                    <hr style={{ margin: '8px 0' }} />
                    <CustomerInstagramSection instagramName={instagramName} />
                </div>
            </Collapse>
        </>
    );
}
